import { beginSessionSnapshot, tagSessionSnapshot } from "../utils/chat/sessionSnapshots";
import {$authHost} from "./index";

const DIRECT_CHAT_API = "api/direct-chat";

export const createOrGetDirectChat = async (targetUserId) => {
    const {data} = await $authHost.post(`${DIRECT_CHAT_API}/create-or-get`, {
        targetUserId
    });

    return data;
};

export const fetchDirectChatSessions = async ({page = 1, limit = 30} = {}) => {
    const snapshot = beginSessionSnapshot();
    const {data} = await $authHost.get(`${DIRECT_CHAT_API}/sessions`, {
        params: {page, limit}
    });
    data.sessions = tagSessionSnapshot(data.sessions, snapshot);
    return data;
};

export const fetchDirectChatMessages = async (chatId, {limit = 50, beforeId = null} = {}) => {
    const {data} = await $authHost.get(`${DIRECT_CHAT_API}/${chatId}/messages`, {
        params: {
            limit,
            ...(beforeId ? {beforeId} : {})
        }
    });

    return data;
};

export const sendDirectChatMessage = async (chatId, payload) => {
    const body = typeof payload === "string"
        ? { content: payload }
        : payload;

    const {data} = await $authHost.post(`${DIRECT_CHAT_API}/${chatId}/messages`, body);

    return data;
};

export const sendDirectChatMessageWithFiles = async (chatId, formData) => {
    const {data} = await $authHost.post(`${DIRECT_CHAT_API}/${chatId}/messages/files`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

    return data;
};

export const markDirectChatRead = async (chatId) => {
    const {data} = await $authHost.post(`${DIRECT_CHAT_API}/${chatId}/read`);
    return data;
};